import { createFileRoute } from "@tanstack/react-router";

import { MonitoringPage } from "@/components/pages/MonitoringPage";
import { FeatureGate } from "@/components/shared/FeatureGate";
import { FEATURES } from "@/lib/features";
import type { MonitoringHistoryView, MonitoringTab } from "@/lib/monitoring";

type MonitoringSearch = {
  tab?: MonitoringTab;
  /** History sub-view; ignored on the Alerts tab. */
  view?: MonitoringHistoryView;
};

const VALID_TABS: MonitoringTab[] = ["alerts", "history"];
const VALID_VIEWS: MonitoringHistoryView[] = ["readings", "resolved-alerts"];

export const Route = createFileRoute("/_authenticated/monitoring/")({
  validateSearch: (search: Record<string, unknown>): MonitoringSearch => ({
    tab: VALID_TABS.includes(search.tab as MonitoringTab)
      ? (search.tab as MonitoringTab)
      : undefined,
    view: VALID_VIEWS.includes(search.view as MonitoringHistoryView)
      ? (search.view as MonitoringHistoryView)
      : undefined,
  }),
  component: MonitoringRoute,
});

function MonitoringRoute() {
  return (
    <FeatureGate feature={FEATURES.MONITORING} featureName="Monitoring">
      <MonitoringPage />
    </FeatureGate>
  );
}
